'use client';
import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Image from 'next/image';
import './footerCarousel.scss';
import { BiSolidChevronRight, BiSolidChevronLeft } from 'react-icons/bi';
import { urlForImage } from '@/sanity/lib/utils';
import { GetCaseStudySettingsResult } from '@/sanity.types';
import Link from 'next/link';

export type footerSlidesType = NonNullable<
  NonNullable<GetCaseStudySettingsResult>['socialProofLogos']
>;

interface FooterCarouselProps {
  footerslides: Array<footerSlidesType>;
}

const FooterCarousel: React.FC<FooterCarouselProps> = ({ footerslides }) => {
  return (
    <Carousel
      slide={true}
      fade={false}
      pause="hover"
      interval={5000}
      indicators={false}
      aria-label="Logo carousel"
      aria-live="polite"
      className="footer-carousel"
      nextIcon={<BiSolidChevronRight />}
      prevIcon={<BiSolidChevronLeft />}
    >
      {footerslides.map((footersliderimages, index) => (
        <Carousel.Item key={index}>
          <div className="d-flex justify-content-center slider-item">
            {footersliderimages.map((image, idx) => (
              <div key={idx} className="mx-2">
                {image?.link ? (
                  <Link href={image?.link || ''}>
                    <Image
                      src={
                        image
                          ? (urlForImage(image?.logoimage)?.url() as string)
                          : ''
                      }
                      alt={`Logo ${idx + 1}`}
                      height={124}
                      width={124}
                      quality={100}
                      sizes="20vw"
                      className="slider-image"
                      role="img"
                    />
                  </Link>
                ) : (
                  <Image
                    src={
                      image
                        ? (urlForImage(image?.logoimage)?.url() as string)
                        : ''
                    }
                    alt={`Logo ${idx + 1}`}
                    height={124}
                    width={124}
                    quality={100}
                    sizes="20vw"
                    className="slider-image"
                    role="img"
                  />
                )}
              </div>
            ))}
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default FooterCarousel;
